// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f152166","455":"29d13963","977":"4a7bdf66"}[chunkId] + ".chunk.js";
};